module.exports = __webpack_public_path__ + "assets/img/images_c.bf716366.png";